import React from 'react';
import Link from 'next/link';
import { useTranslation } from '@separate/hooks/translation';
import styles from '../referAFriend.module.scss';

export default function ReferAFriendTNC() {
  const { t } = useTranslation();

  return (
    <Link href='/legal/podersalud-referral-terms-and-conditions'>
      <a
        target='_blank'
        rel='noopener noreferrer'
        className={styles.termsAndConditions}
      >
        {t('user.refer_a_friend.terms_and_conditions')}
      </a>
    </Link>
  );
}
